// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Education_educations__GNJh7 .Education_education-wrapper__cOG6u {
  background: white;
  padding: 15px 20px;
  border-radius: 5px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 25px;
}
.Education_educations__GNJh7 .Education_education-wrapper__cOG6u .Education_education__b72-D .Education_education-info__W1l9l .Education_inst-name__aia5- {
  font-weight: bold;
}
.Education_educations__GNJh7 .Education_education-wrapper__cOG6u .Education_delete-education__sZ8i8 {
  margin-top: 5px;
}
.Education_educations__GNJh7 .Education_education-wrapper__cOG6u .Education_delete-education__sZ8i8 svg {
  cursor: pointer;
}
.Education_educations__GNJh7 .Education_education-wrapper__cOG6u .Education_delete-education__sZ8i8 svg path {
  stroke: red;
}
.Education_educations__GNJh7 .Education_add-button__iMLYi {
  margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Admin/Pages/PersonalProfile/Components/Education/Education.module.scss"],"names":[],"mappings":"AACE;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;AAAJ;AAGQ;EACE,iBAAA;AADV;AAKI;EACE,eAAA;AAHN;AAIM;EACE,eAAA;AAFR;AAGQ;EACE,WAAA;AADV;AAME;EACE,mBAAA;AAJJ","sourcesContent":[".educations {\n  .education-wrapper {\n    background: white;\n    padding: 15px 20px;\n    border-radius: 5px;\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    margin-bottom: 25px;\n    .education {\n      .education-info {\n        .inst-name {\n          font-weight: bold;\n        }\n      }\n    }\n    .delete-education {\n      margin-top: 5px;\n      svg {\n        cursor: pointer;\n        path {\n          stroke: red;\n        }\n      }\n    }\n  }\n  .add-button {\n    margin-bottom: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"educations": `Education_educations__GNJh7`,
	"education-wrapper": `Education_education-wrapper__cOG6u`,
	"education": `Education_education__b72-D`,
	"education-info": `Education_education-info__W1l9l`,
	"inst-name": `Education_inst-name__aia5-`,
	"delete-education": `Education_delete-education__sZ8i8`,
	"add-button": `Education_add-button__iMLYi`
};
export default ___CSS_LOADER_EXPORT___;
